(function () {
  const loadMoreSelector = '[data-collection-load-more]';
  let isLoading = false;

  function getSectionId() {
    return document.getElementById('product-grid')?.dataset.id;
  }

  function getSectionUrl(url) {
    const sectionId = getSectionId();
    const nextUrl = new URL(url, window.location.origin);

    if (sectionId) {
      nextUrl.searchParams.set('section_id', sectionId);
    }

    return nextUrl.toString();
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getElement(doc, selector) {
    return doc.querySelector(selector);
  }

  function setLoading(button, loading) {
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.classList.toggle('collection-products__load-more--loading', loading);
  }

  function updateFooter(currentFooter, nextFooter) {
    if (!currentFooter || !nextFooter) return;
    currentFooter.innerHTML = nextFooter.innerHTML;
  }

  function updateCount() {
    const currentCount = document.getElementById('ProductCountDesktop');
    const shownCount = document.querySelectorAll('#product-grid > .grid__item').length;
    const shownCountElement = currentCount?.querySelector('span');

    if (shownCountElement && shownCount) {
      shownCountElement.textContent = shownCount;
    }
  }

  async function loadMore(button) {
    if (isLoading || !button.href) return;

    const grid = document.getElementById('product-grid');
    const currentFooter = button.closest('.collection-products__footer');
    if (!grid || !currentFooter) return;

    isLoading = true;
    setLoading(button, true);

    try {
      const response = await fetch(getSectionUrl(button.href));
      if (!response.ok) throw new Error('Unable to load more products.');

      const doc = parseHtml(await response.text());
      const nextGrid = doc.getElementById('product-grid');
      const nextFooter = getElement(doc, '.collection-products__footer');

      if (!nextGrid) throw new Error('Product grid not found in response.');

      const nextItems = Array.from(nextGrid.querySelectorAll(':scope > .grid__item'));
      if (!nextItems.length) {
        updateFooter(currentFooter, nextFooter);
        return;
      }

      grid.append(...nextItems);
      updateFooter(currentFooter, nextFooter);
      updateCount();
    } catch (error) {
      console.error(error);
      window.location.href = button.href;
    } finally {
      isLoading = false;
      setLoading(button, false);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(loadMoreSelector);
    if (!button) return;

    event.preventDefault();
    loadMore(button);
  });
})();
